// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTreatmentSummary_root__2WvfQ","row":"ProcedureTreatmentSummary_row__3Rcu9"};